import React = require('react');
import {IQuestion} from './models';
import {Choice} from "./Choice";
import {IFilterChoices} from "./models";
import {IChoice} from "./models";
import Immutable = require('immutable');

interface Properties {
    errors?: string[]
}

interface Callbacks {
}

interface Props extends Properties, Callbacks {}

interface State {
}

export class FormGroup extends React.Component<Props, State> {

    render() {

        var validationClass = this.props.errors ? ' has-error' : '';

        var validationMessages;

        if (this.props.errors) {
            validationMessages = Immutable.List(this.props.errors).map( (errorMessage, index) =>
                <span className="help-block" key={index}>{errorMessage}</span>
            ).toArray();
        }

        return <div className={"form-group" + validationClass}>
            {this.props.children}
            {validationMessages}
        </div>;
    }
}
